import { render } from "./login.vue?vue&type=template&id=3116fb50"
import script from "./loginComponent.js?vue&type=script&lang=js"
export * from "./loginComponent.js?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=3116fb50&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__